import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { Environment } from 'dashboard/models/environment';
import { WebhookEvent } from 'dashboard/models/webhook-event';
import { setWebhookEvents, WebhookEventsFilterParams } from 'dashboard/redux/slices/webhook-events';
import { ApiEndpoint, PaginationParams } from 'lib/interfaces/api';

export function loadWebhookEventList({
  currentEnvironment,
  currentPage,
  pageSize,
  filters,
  abortSignal,
}: {
  currentEnvironment: Environment;
  currentPage: number;
  pageSize: number;
  filters: WebhookEventsFilterParams;
  abortSignal?: AbortSignal;
}) {
  return async (dispatch: Dispatch) => {
    const paramsFull = {
      ...createParamsForList(currentEnvironment, filters),
      page: {
        number: currentPage,
        size: pageSize,
      },
      signal: abortSignal,
    };

    const { data: webhookEvents, meta: paginationParams } =
      await SessionClientDashboard.listResource<WebhookEvent, PaginationParams>(
        ApiEndpoint.WebhookEvent,
        paramsFull,
      );

    dispatch(setWebhookEvents({ webhookEvents, paginationParams }));
  };
}

function createParamsForList(currentEnvironment: Environment, filters: WebhookEventsFilterParams) {
  const { eventId, webhookId, status, updatedAtStart, updatedAtEnd, omni } = filters;

  return {
    filter: {
      'environment-id': currentEnvironment.id,
      status,
      'event-id': eventId,
      'webhook-id': webhookId,
      omni,
      'updated-at-start': updatedAtStart && updatedAtStart.toString(),
      'updated-at-end': updatedAtEnd && updatedAtEnd.toString(),
    },
  };
}
